import AuthenticationContext from 'adal-angular/lib/adal.js'

//Display name: Gestor de enlaces Educamos
//Application(client) ID: 7b8d98d9-60a7-4c82-99cb-e0a1ee4c1c84
//Directory(tenant) ID: 0dca57f1-8ca8-4d39-b81d-345f03cbb5e7
//Object ID: 4433451e-8ffe-48bc-bc51-7e04de488c75
//Client secret: =O5i-*TOmX.lvp5JKP6nJhnMRhUf1Ox5

import config from '../config'
//const config = {
//    tenant: '0dca57f1-8ca8-4d39-b81d-345f03cbb5e7',
//    clientId: '7b8d98d9-60a7-4c82-99cb-e0a1ee4c1c84',
//    redirectUri: 'http://localhost:59235',
//  cacheLocation: 'localStorage'
//};

export default {
  authenticationContext: null,
  /**
   * @return {Promise}
   */
  initialize() {
    this.authenticationContext = new AuthenticationContext(config);

    return new Promise((resolve, reject) => {
      if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
        // redirect to the location specified in the url params.
        this.authenticationContext.handleWindowCallback();
      }
      else {
        // try pull the user out of local storage
        let user = this.authenticationContext.getCachedUser();

        if (user) {
          resolve();
        }
        else {
          // no user at all - go sign in.
          //this.signIn();
            resolve();
        }
      }
    });
  },
  /**
   * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
   */
  acquireToken() {
    return new Promise((resolve, reject) => {
        this.authenticationContext.acquireToken('f42d85da-c657-4da3-af2d-18f384affa50', (error, token) => {
        if (error || !token) {
          return reject(error);
        } else {
          return resolve(token);
        }
      });
    });
  },
  /**
   * Issue an interactive authentication request for the current user and the api resource.
   */
  acquireTokenRedirect() {
      this.authenticationContext.acquireTokenRedirect('f42d85da-c657-4da3-af2d-18f384affa50');
  },
  /**
   * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
   */
  isAuthenticated() {
    // getCachedToken will only return a valid, non-expired token.
      if (this.authenticationContext !== null && this.authenticationContext.getCachedToken(config.clientId)) { return true; }
    return false;
  },
  /**
   * @return An ADAL user profile object.
   */
  getUserProfile() {
    return this.authenticationContext.getCachedUser().profile;
  },
  signIn() {
    this.authenticationContext.login();
  },
  signOut() {
    this.authenticationContext.logOut();
  }
}
